
export const CUSTOM_METRICS = {
  BusinessTimesUpdateSuccess: {
    KEY: 'BAppShopSettingBusinessTimesUpdateSuccess',
  },
  BusinessTimesUpdateNum: {
    KEY: 'BAppShopSettingBusinessTimesUpdateNum',
  },
  SpecialTimesUpdateNum: {
    KEY: 'BAppShopSettingSpecialTimesUpdateNum',
  },
  SpecialTimesUpdateSuccess: {
    KEY: 'BAppShopSettingSpecialTimesUpdateSuccess',
  },
  JumpSunccess: {
    KEY: 'BAppShopSettingJumpSunccess',
  },
  JumpNum: {
    KEY: 'BAppShopSettingJumpNum',
  },
  Crash: {
    KEY: 'BAppShopSettingCrash',
  },
}

export const LvPoint = {
  'cid': {
    Index_BusinessTime: 'c_sailor_b_kssrgkoe',
    Index_SpecialTime: 'c_sailor_b_dhwbyoc0',
    BusinessTimeSet: 'c_sailor_b_igecy01l',
    SpecialTimeSet: 'c_sailor_b_1kuoo9e8',
    Index_More: 'c_sailor_b_nib9r1ff',
  },
  'bid': {
    BusinessTime: 'b_sailor_b_t3uef9on_mc',
    SpecialTime: 'b_sailor_b_6mr9cwbu_mc',
    ShopStatusSet: 'b_sailor_b_ufgm91ty_mc',
    BusinessTimeSet: 'b_sailor_b_1lns0g59_mc',
    SpecialTimeSet: 'b_sailor_b_yxpquqoe_mc',
    BusinessTimeSetCancel: 'b_sailor_b_uol5ikq6_mc',
    BusinessTimeSetSubmit: 'b_sailor_b_yw5bhsp5_mc',
    SpecialTimeSetSelectHoliday: 'b_sailor_b_vcxg3zfd_mc',
    SpecialTimeSetCancel: 'b_sailor_b_7witltpo_mc',
    SpecialTimeSetSubmit: 'b_sailor_b_9vwl7mfu_mc',
    MoreShopSettings: 'b_sailor_b_7u2f2oij_mc',
    MoreCustomerReview: 'b_sailor_b_vho7jt9r_mc',
    MoreRestaurant: 'b_sailor_b_g5pdfaxs_mc',
    MoreHelpCenter: 'b_sailor_b_mnzzm8hz_mc',
    MoreDeliveryMall: 'b_sailor_b_3obc0e6k_mc',
    University: 'b_sailor_b_ylskkr7k_mc',
    Hotline: 'b_sailor_b_jq07c8z6_mc',
  },
}